import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ef9e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home_main_cnt1"
}
const _hoisted_2 = { id: "contents1" }
const _hoisted_3 = { class: "com_sec1" }
const _hoisted_4 = { class: "com_inner1 clearfix" }
const _hoisted_5 = { class: "com_contents1" }
const _hoisted_6 = { class: "main_column1" }
const _hoisted_7 = { class: "vertical_components" }
const _hoisted_8 = { class: "horizontal_component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_CarouselComponent = _resolveComponent("CarouselComponent")!
  const _component_IconMenuComponent = _resolveComponent("IconMenuComponent")!
  const _component_AnnouncementAreaComponent = _resolveComponent("AnnouncementAreaComponent")!
  const _component_NewsAreaComponent = _resolveComponent("NewsAreaComponent")!
  const _component_FavoritePageComponent = _resolveComponent("FavoritePageComponent")!
  const _component_RecentlyViewedPagesComponent = _resolveComponent("RecentlyViewedPagesComponent")!
  const _component_SideSliderComponent = _resolveComponent("SideSliderComponent")!
  const _component_RelatedInfoLinksComponent = _resolveComponent("RelatedInfoLinksComponent")!
  const _component_LoginPopupModalComponent = _resolveComponent("LoginPopupModalComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_FloatingLinkComponent = _resolveComponent("FloatingLinkComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent),
      (_ctx.isDataFetched == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_CarouselComponent),
            _createVNode(_component_IconMenuComponent)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AnnouncementAreaComponent),
            _createVNode(_component_NewsAreaComponent),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_FavoritePageComponent),
                  _createVNode(_component_RecentlyViewedPagesComponent)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_SideSliderComponent)
                ])
              ])
            ]),
            _createVNode(_component_RelatedInfoLinksComponent)
          ])
        ]),
        (_ctx.isLoginPopupPermission && _ctx.currentLoginPopup !== null)
          ? (_openBlock(), _createBlock(_component_LoginPopupModalComponent, {
              key: 0,
              isOpen: true,
              isPreview: false,
              categoryId: _ctx.currentLoginPopup.categoryId,
              contentsId: _ctx.currentLoginPopup.contentsId,
              onClosed: _ctx.handleLoginPopupModalClosed
            }, null, 8, ["categoryId", "contentsId", "onClosed"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_FooterComponent)
    ]),
    (_ctx.isIncentiveEntry && _ctx.isIncentivePermission)
      ? (_openBlock(), _createBlock(_component_FloatingLinkComponent, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_BackToTop)
  ], 64))
}